// src/pages/DiaDEMOverview.jsx
import React from "react";
import ContactForm3 from "../components/ContactForm3";
import Footer from "../components/Footer";


export default function DiaDEMOverview() {
  return (
    <>
    <section className="min-h-screen py-20 px-6 sm:px-8 bg-[#1A1631] text-white">
      <div className="max-w-5xl mx-auto">
        {/* Back Link */}
        <a
          href="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          <span className="mr-2 text-lg">←</span> Back to main site
        </a>

        {/* Page Title */}
        <h1 className="text-4xl md:text-5xl font-bold mb-8">
          <span className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            The DiaDEM™ Platform
          </span>
        </h1>

        {/* Intro Paragraph */}
        <p className="text-lg text-slate-300 mb-12 max-w-3xl">
          DiaDEM™ is your digital materials discovery engine, streamlining the journey from idea to practical material. What used to take years, can now take days.
          Combining a chemically-exhaustive and experimentally-calibrated dataset, advanced property calculators, and direct supplier integration, it empowers researchers
          to reveal, evaluate, and source novel molecules with unprecedented speed.
        </p>

        {/* Features Section */}
        <div className="space-y-6">
          <h2 className="text-2xl font-semibold text-orange-300 mb-4">What DiaDEM™ Offers</h2>
          <ul className="list-disc list-inside text-slate-300 space-y-2">
            <li>50+ million molecules with calibrated excited state properties, solubility, toxicity and procurement information. </li>
            <li>On-demand, click-and-compute calculators for charge mobility, morphology, crystal structure prediction, IP/EA, Stokes shift and more.</li>
            <li>Direct procurement of any material from the platform.</li>
            <li>Scalable for projects from academic research to industrial R&amp;D.</li>
          </ul>
        </div>

{/* Diagram/Figure Placeholder */}
<div className="my-12 flex justify-center">
  <div className="bg-[#221E3F] rounded-xl w-full max-w-5xl h-48 flex items-center justify-center text-slate-400 text-sm px-4">
    <div className="flex flex-row items-center justify-center space-x-8 text-center text-slate-300">
      
      {/* Step 1 */}
      <div>
        <div className="text-4xl mb-2">🔍</div>
        <p className="font-semibold">Search by Property</p>
        <p className="text-sm text-slate-400 mt-1">
          Identify candidates from 50M+ molecules
        </p>
      </div>

      {/* Arrow */}
      <div className="text-orange-400 text-2xl">→</div>

      {/* Step 2 */}
      <div>
        <div className="text-4xl mb-2">⚙️</div>
        <p className="font-semibold">Compute Properties</p>
        <p className="text-sm text-slate-400 mt-1">
          On-demand advanced simulations
        </p>
      </div>

      {/* Arrow */}
      <div className="text-orange-400 text-2xl">→</div>

      {/* Step 3 */}
      <div>
        <div className="text-4xl mb-2">🛒</div>
        <p className="font-semibold">Order to Lab</p>
        <p className="text-sm text-slate-400 mt-1">
          Instant material procurement
        </p>
      </div>

    </div>
  </div>
</div>
        {/* Call to Action */}
        <p className="text-lg text-slate-300 mb-8 max-w-3xl">
          Whether you're optimising optoelectronic devices or exploring novel functional materials, DiaDEM™ equips your team
          with the data and computational tools to move faster and smarter.
        </p>

{/* Subtle Contact Section */}
<div className="mt-16 border-t border-slate-700 pt-8">
  <h2 className="text-xl font-semibold text-slate-300 mb-4">
    Want to learn more?
  </h2>
  <p className="text-slate-400 mb-6 max-w-2xl">
    If you'd like a guided walkthrough or have specific project needs, feel free to get in touch. Our team can help you explore how DiaDEM™ fits your research.
  </p>
  <ContactForm3 />
</div>

      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
